import {
  COUNTRY_CODE,
  formatLocal,
  localFromStored,
  normalizeLocal,
  toE164,
} from '@/lib';
import PropTypes from 'prop-types';
import './PhoneInput.css';

const LABEL_STYLE = {
  fontSize: '0.8125rem',
  fontWeight: 500,
  color: 'var(--ink-2)',
};

const ERROR_STYLE = {
  fontSize: '0.75rem',
  color: 'var(--err)',
};

/**
 * Chilean phone field. The "+56" country code is a fixed, non-editable prefix
 * rendered inside the same input box; only the 9 local digits are editable and
 * are auto-grouped as "9 1234 1234". Reports the E.164 value (`+56XXXXXXXXX`)
 * via `onChange`. Visual styling matches `.form-input.mono`.
 */
export default function PhoneInput({
  id,
  label,
  required,
  value,
  onChange,
  error,
}) {
  const display = formatLocal(localFromStored(value));

  function handleChange(e) {
    onChange(toE164(normalizeLocal(e.target.value)));
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      {label && (
        <label htmlFor={id} style={LABEL_STYLE}>
          {label}
          {required ? ' *' : ''}
        </label>
      )}
      <div className={error ? 'phone-input error' : 'phone-input'}>
        <span className="phone-input__cc">{COUNTRY_CODE}</span>
        <input
          id={id}
          className="phone-input__field"
          value={display}
          onChange={handleChange}
          inputMode="numeric"
          autoComplete="tel-national"
          placeholder="9 1234 1234"
        />
      </div>
      {error && <span style={ERROR_STYLE}>{error}</span>}
    </div>
  );
}

PhoneInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};
